import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentChatConversation } from "types/generated";

import { CHAT_CONVERSATION_BASIC_FRAGMENT } from "../gql";

type ChatConversationsData = {
  intentChatConversations: IntentChatConversation[];
};

type ChatConversationsVariables = {
  page?: number | null;
  perPage?: number | null;
  search?: string | null;
};

export const CHAT_CONVERSATIONS: TypedDocumentNode<
  ChatConversationsData,
  ChatConversationsVariables
> = gql`
  query ChatConversations($page: Int, $perPage: Int, $search: String) {
    intentChatConversations(page: $page, perPage: $perPage, search: $search) {
      ...ChatConversationBasic
    }
  }
  ${CHAT_CONVERSATION_BASIC_FRAGMENT}
`;
